import { DefaultModal } from 'views/components/modals/components/default-modal';
import { useThemeQueries } from 'views/theme';
import { GerenteCadastro } from './components/cadastro-gerente';

type Props = {
  openned: boolean;
}

export const GerenteModal = ({ openned }: Props) => {
  const { isMobile } = useThemeQueries()
  return (
    <DefaultModal
      minWidth={isMobile ? '0' : "600px"}
      open={openned || false}
      variant={"temporary"}
      anchor="right"
    >
      {openned && <GerenteCadastro/>}
    </DefaultModal>
  );
};
